import { z } from 'zod';
import { LEAD_SOURCES } from './enums.js';
/**
 * Bulk lead import — GBV-DEV-2026-001 Section 09.
 *
 * Three steps, and the split is the point: upload and parse, then map columns,
 * then commit. Nothing touches the Lead table until the operator has seen how
 * many rows will be created, how many skipped, and why.
 */
/** Lead fields a CSV column may be mapped onto. */
export const IMPORTABLE_FIELDS = [
    'name',
    'phone',
    'altPhone',
    'email',
    'company',
    'city',
    'source',
    'stage',
    'temperature',
    'valuePaise',
    'notes',
];
export const IMPORTABLE_FIELD_LABELS = {
    name: 'Name',
    phone: 'Phone',
    altPhone: 'Alternate phone',
    email: 'Email',
    company: 'Company',
    city: 'City',
    source: 'Source',
    stage: 'Stage',
    temperature: 'Temperature',
    valuePaise: 'Deal value (₹)',
    notes: 'Notes',
};
/** Without these two a row is not a lead, it is a string. */
export const REQUIRED_IMPORT_FIELDS = ['name', 'phone'];
export const DUPLICATE_ACTIONS = ['SKIP', 'ENRICH', 'CREATE'];
export const DUPLICATE_ACTION_LABELS = {
    SKIP: {
        label: 'Skip the row',
        hint: 'Leave the existing lead exactly as it is. Safest, and the default.',
    },
    ENRICH: {
        label: 'Fill in blanks only',
        hint: 'Add an email or city where the existing lead has none. Never overwrites.',
    },
    CREATE: {
        label: 'Create a second lead',
        hint: 'Only when two different people genuinely share a number.',
    },
};
export const importMappingSchema = z.object({
    /**
     * Source column name → target field. Unmapped columns are simply absent.
     *
     * Plain strings, not an enum of lead fields: which fields are legal depends
     * on what is being imported, and that is recorded on the job rather than
     * sent with the mapping. The server filters against the entity's own field
     * list, so an unknown name is dropped rather than trusted.
     */
    mapping: z.record(z.string().max(60)),
    onDuplicate: z.enum(DUPLICATE_ACTIONS).default('SKIP'),
    defaultSource: z.enum(LEAD_SOURCES).default('IMPORT'),
    defaultOwnerId: z.string().cuid().optional().nullable(),
});
/** How many rows one upload may carry. Beyond this, split the file. */
export const MAX_IMPORT_ROWS = 50_000;
/** How many issues are kept per job. Enough to fix a file, not a second copy of it. */
export const MAX_IMPORT_ISSUES = 500;
//# sourceMappingURL=import.schema.js.map